:host {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.hmc-banner {
  flex: 1;
  display: flex;
  padding: 20px 30px 10px;
  justify-content: center;
  flex-direction: column;
}

.hmc-banner.is-short {
  min-height: 115px;
  height: 100%;
  padding: 0 28px;
}

.hmc-banner.is-square {
  min-height: 170px;
}

.hmc-banner.is-extended {
  min-height: 108px;
}

@media screen and (min-width: 980px) {
  .hmc-banner.is-extended {
    flex-direction: row;
    padding: 0 60px;
    justify-content: space-between;
    align-items: center;
  }
}

.hmc-banner__text-block.is-short {
  text-align: center;
}

.hmc-banner__text-block.is-square {
  margin-bottom: 12px;
}

@media screen and (max-width: 979px) {
  .hmc-banner__text-block.is-extended {
    margin-bottom: 12px;
  }
}

.hmc-banner__button.is-square, .hmc-banner__button.is-extended {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  height: 40px;
  width: 100%;
  background-color: #42b4e6;
  color: #ffffff;
  line-height: 20px;
  border-radius: 2px;
  margin: 0;
}

.hmc-banner__button.is-square:hover, .hmc-banner__button.is-extended:hover {
  cursor: pointer;
  background: linear-gradient(#59bde9, #42b4e6 50%);
}

@media screen and (max-width: 979px) {
  .hmc-banner__button.is-square, .hmc-banner__button.is-extended {
    font-size: 12px;
  }
}

@media screen and (min-width: 980px) {
  .hmc-banner__button.is-square, .hmc-banner__button.is-extended {
    font-size: 16px;
  }
}

@media screen and (max-width: 979px) {
  .hmc-banner__button.is-extended {
    width: 192px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 980px) {
  .hmc-banner__button.is-extended {
    flex: 0 0 192px;
  }
}

.hmc-banner__heading {
  line-height: 25px;
  text-align: center;
}

.hmc-banner__heading.is-short {
  margin: 0 0 8px;
  max-width: 100%;
  color: #333333;
  font-size: 13px;
  line-height: 15px;
}

.hmc-banner__heading.is-square, .hmc-banner__heading.is-extended {
  margin: 0 0 5px;
  color: #626469;
}

@media screen and (max-width: 979px) {
  .hmc-banner__heading.is-square, .hmc-banner__heading.is-extended {
    font-size: 14px;
  }
}

@media screen and (min-width: 980px) {
  .hmc-banner__heading.is-square, .hmc-banner__heading.is-extended {
    font-size: 16px;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .hmc-banner__heading.is-extended {
    text-align: left;
    margin-right: 20px;
  }

  :host([dir="rtl"]) .hmc-banner__heading.is-extended {
    text-align: right;
    margin-left: 20px;
  }
}

.hmc-banner__text {
  text-align: center;
}

.hmc-banner__text.is-short {
  display: inline;
  font-size: 13px;
  line-height: 15px;
  text-transform: capitalize;
}

.hmc-banner:hover .hmc-banner__text.is-short {
  text-decoration: underline;
}

.hmc-banner__text.is-square, .hmc-banner__text.is-extended {
  font-size: 12px;
  line-height: 18px;
  font-weight: normal;
  color: #626469;
  text-align: center;
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .hmc-banner__text.is-extended {
    text-align: left;
  }

  :host([dir="rtl"]) .hmc-banner__text.is-extended {
    text-align: right;
  }
}

.hmc-banner__text-content.is-short {
  background: none;
  color: #42b4e6;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
  font-family: inherit;
  font-size: 15px;
  line-height: 20px;
  font-weight: normal;
  text-align: center;
}

.hmc-banner__text-content.is-short:hover {
  text-decoration: underline;
}

.hmc-banner__text-content.is-short:hover {
  text-decoration: none;
}

.hmc-banner__text-arrow-icon.is-short {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  position: relative;
}

:host(:not([dir="rtl"])) .hmc-banner__text-arrow-icon.is-short {
  left: 3px;
}

:host([dir="rtl"]) .hmc-banner__text-arrow-icon.is-short {
  right: 3px;
  transform: scaleX(-1);
}

.banner-container--prerender {
  min-height: 110px;
}